export const ALLOWED_IMAGE_FILE_EXTENSIONS: Readonly<string[]> = [
  'image/png',
  'image/jpeg',
  'image/jpg',
];
const MAX_IMAGE_UPLOAD_SIZE = 1 * 1024 * 1024; // 1MB

export type ProfileValidatorResult = 'SUCCESS' | 'INVALID_EXTENSION' | 'INVALID_SIZE';

export const validImageFileExtensionType = (file: File) =>
  ALLOWED_IMAGE_FILE_EXTENSIONS.includes(file.type);

const validateImageFileSize = (file: File) => file.size <= MAX_IMAGE_UPLOAD_SIZE;

export const useProfileImageValidator = () => {
  const validateImageFile = ({
    file,
    onChange,
  }: {
    file: File;
    onChange: (result: ProfileValidatorResult) => void;
  }): boolean => {
    if (!validImageFileExtensionType(file)) {
      onChange('INVALID_EXTENSION');

      return false;
    }

    if (!validateImageFileSize(file)) {
      onChange('INVALID_SIZE');

      return false;
    }

    onChange('SUCCESS');

    return true;
  };

  return { validateImageFile };
};
